module.exports = __webpack_public_path__ + "static/media/book-builder-rewards.1f56ddf9.png";